// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_postRejectAttendanceBonus = (path: TSpecPathPostRejectAttendanceBonus) => {
  let res = "/attendance-bonus/:id/reject";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_postRejectAttendanceBonus = RequestHandler<TSpecPathPostRejectAttendanceBonus, any, TSpecBodyPostRejectAttendanceBonus, TSpecQueryPostRejectAttendanceBonus, {}>;

export interface TSpecPathPostRejectAttendanceBonus { id: string; }

export interface TSpecBodyPostRejectAttendanceBonus {
  note?: string;
}

export interface TSpecQueryPostRejectAttendanceBonus {
  AppVersion?: string;
  AppUser?: string;
}
